var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-card',{staticClass:"card pa-8 ma-3 d-flex justify-center align-center",class:_vm.selectedItem === _vm.Items.plan ? 'global-selectedRamo' : 'global-ramoCard',attrs:{"outlined":""},on:{"click":function($event){return _vm.selectRamo(_vm.Items.plan)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }